import { SOCKET_PING_INTERVAL } from '@/utils/constants'
import { useEffect } from 'react'
import { useState } from 'react'
// import { socketURL } from '../api/request'
// import NetInfo from '@react-native-community/netinfo'
import { useRef } from 'react'
import useNotificationStorageHook from './useNotificationStorageHook'
import { SocketEventType, SocketMessage } from '@/types/notification'
import useAppStore from '@/store/useAppStore'
import { convertToGMT } from '@/utils/helper'
// import { updateOnlineStatus } from '../stores/user.reducer'
// import { showToast } from '../components/CustomToast'
// import { handleSocketMessage } from '../utils/SocketNotifier'
// import { SOCKET_PING_INTERVAL } from '../../constant'

const messagesToSkip = ['Hi--No events to send', 'Hi--Events queued', 'Hi--invalid input data']

// Every real build (.env.testing/.env.staging/.env.prod) sets these to the
// stage-correct API Gateway domain — the testing literal is only a fallback
// for a stray local build missing the env vars, so staging/prod builds don't
// silently connect to the testing socket.
const socketURL =
  process.env.REACT_APP_WS_DOMAIN && process.env.REACT_APP_WS_STAGE
    ? `wss://${process.env.REACT_APP_WS_DOMAIN}/${process.env.REACT_APP_WS_STAGE}`
    : 'wss://1gt20kn9ma.execute-api.us-east-1.amazonaws.com/testing'
const useWebSocketHook = () => {
  const [isConnected, setIsConnected] = useState(false)
  const [socket, setSocket] = useState<WebSocket | null>(null)

  const socketAlive = useRef(false) // To check if server is responding to ping
  const pingInterval = useRef<NodeJS.Timer | null>(null)
  const ws = useRef<WebSocket | null>(null)
  const [userNameGlobal, setUserNameGlobal] = useState('')

  const { addMessage } = useNotificationStorageHook()

  const stopPing = () => {
    if (pingInterval.current) clearInterval(pingInterval.current)
  }

  useEffect(() => {
    // Monitor network connectivity changes

    const unsubscribe = () => {}
    /*
    const unsubscribe = NetInfo.addEventListener((state) => {
      if (state.isConnected && !isConnected) {
        // Reconnect WebSocket if network connection is restored
        connectWebSocket(userNameGlobal)
      }
    })
     */

    return () => {
      if (socket) {
        console.log('~~~~~~~~~~ [DISCONNECT REQUEST] ~~~~~~~~~~')
        stopPing()
        if (socket && ws.current) {
          socket.close(1000, 'Connection closed forcefully')
          ws.current.close(1000, 'Connection closed forcefully')
        }
      }
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (userNameGlobal?.length > 0) {
      connectWebSocket(userNameGlobal)
    } else {
      // clearInterval(pingInterval.current)
    }
  }, [userNameGlobal])

  const connectWebSocket = (userName: string) => {
    if (ws?.current != null && ws?.current?.readyState == WebSocket.OPEN) {
      return
    } else if (userName?.length > 0) {
      console.log('~~~~~~~~~~ [CONNECTING] ~~~~~~~~~~')
      ws.current = new WebSocket(socketURL)

      // Events
      ws.current.onopen = () => {
        console.log('~~~~~~~~~~ [CONNECTED] ~~~~~~~~~~')
        setUserNameGlobal(userName)
        setSocket(ws.current)
        setIsConnected(true)
        socketAlive.current = true

        try {
          console.log('Username: ', userName)
          if (userName?.length > 0) {
            const socketData = {
              action: 'sendMessage',
              userName,
            }
            const json = JSON.stringify(socketData)
            ws.current?.send(json)

            sendPing()
            stopPing()

            pingInterval.current = setInterval(sendPing, SOCKET_PING_INTERVAL)
          }
        } catch (err) {
          console.log('Error Sending: ', err)
        }
      }

      ws.current.onmessage = (event) => {
        const { data: socketMessage } = event
        console.log('~~~~~~~~~~ [MESSAGE RECEIVED] ~~~~~~~~~~')
        console.log('WebSocket message received:', socketMessage)
        socketAlive.current = true

        if (!messagesToSkip.includes(socketMessage)) {
          const parsedMessage: SocketMessage = JSON.parse(socketMessage)
          // Ignoring own events.
          if (userNameGlobal != parsedMessage?.eventData?.sourceUserName) {
            addMessage(parsedMessage)
          } else {
            console.log('SENT TO SELF')
          }

          // Live "who's viewing this" presence — separate from the notification
          // list above (isSocketEventSupported deliberately excludes topic_view
          // from the bell). Note a fresh connection replays any topic_view
          // events queued while this socket was offline, so viewedAt comes from
          // the server's eventDateTime, not receipt time, and staleness is
          // filtered at read time in useTopicViewers.
          if (parsedMessage?.eventData?.eventType === SocketEventType.TOPIC_VIEWED) {
            const { objectID, sourceUserID, sourceUserFullName, profilePicThumbURL, eventDateTime } =
              parsedMessage.eventData
            if (objectID && sourceUserID) {
              useAppStore.getState().recordTopicView(objectID, {
                sourceUserID,
                sourceUserFullName,
                profilePicThumbURL,
                viewedAt: new Date(convertToGMT(eventDateTime)).getTime(),
              })
            }
          }
        }
      }

      ws.current.onerror = (error) => {
        console.log('~~~~~~~~~~ [WEBSOCKET ERROR] ~~~~~~~~~~')
        console.error('WebSocket error:', error)
      }

      ws.current.onclose = (event) => {
        console.log('Close Event: ', event)
        console.log('~~~~~~~~~~ [WEBSOCKET CLOSED] ~~~~~~~~~~')
        // showToast('error', 'SOCKET DISCONNECTED');
        setSocket(null)
        ws.current = null
        setIsConnected(false)

        // Reconnect when it was not from logout.
        if (event.code != 1000) {
          setTimeout(() => {
            connectWebSocket(userNameGlobal)
          }, 3000)
        }
      }
    }
  }

  const sendPing = () => {
    if (ws?.current != null) {
      if (ws.current.readyState == WebSocket.OPEN) {
        if (socketAlive.current == false) {
          connectWebSocket('')
        }

        const pingMessage = JSON.stringify({ type: 'ping' })
        ws?.current?.send(pingMessage)
      } else {
        console.log('WebSocket connection is not open')
      }
    }
  }

  const disconnect = () => {
    console.log('~~~~~~~~~~ [DISCONNECT REQUEST] ~~~~~~~~~~')
    //clearInterval(pingInterval.current)
    stopPing()
    socket?.close(1000, 'Connection closed from logout')
    ws.current?.close(1000, 'Connection closed from logout')
  }

  return { socket, connectWebSocket, disconnect }
}

export default useWebSocketHook
